export default {
    okmain:{
      lang:"中文(简体)",
      openkylinweburl:'https://www.openkylin.top/',
      openkylinsigurl:'https://www.openkylin.top/sig/application-cn.html',
      openkylinmemberurl:'https://www.openkylin.top/community/partner-cn.html',
      nav1:"数据总览",
      nav2:"社区贡献",
      nav3:"返回官网",
      nav_sig: "SIG兴趣小组贡献",
      nav_member: "单位成员贡献",
      nav_number: "个人成员贡献",
      user:"用户 Users",
      deploy: "部署量 Deployments",
      contributors:"贡献者 Contributors",
      member:"社区会员 Members",
      university:"高校站 University",
      sig:"特别兴趣小组 SIG",
      userGroup:"用户组 UserGroup",
      repositories:"代码仓库 Repositories",
      commits:"提交请求 Commits",
      pr:"合并请求 PR",
      issues:"需求&问题 Issues",
      code_lines: "代码行数",
      f_copyright:"Copyright©2026 openKylin 版权所有 京ICP备2020036654号-21",
      f_garight:"京公网安备11030102011760号",
      f_code:"代码仓库",
      f_joinmember:"加入会员",
      f_joinsig:"加入SIG",
      f_updatetime:"更新时间",
      f_frequency:"频率",
      f_times:"小时一次",
      c_devel_contribute:"开发者贡献",
      c_member_contribute:"单位成员贡献",
      c_sig_contribute:"SIG兴趣小组贡献",
      c_time1:'一个月内',
      c_time2:'半年内',
      c_time3:'一年内',
      c_all:'全部',
      c_metrics:'度量指标',
      c_time: "时间长度",
      c_points:'积分',
      c_range:'显示范围',
      c_sort:'排序',
      c_giteename:"Gitee名",
      c_membername:"成员名称",
      c_signame:"SIG名称",
      c_communityname:"社区名",
      c_contributionvalue:"贡献值",
      c_pointvalue:"积分值",
      c_data_limit_hint:"数据量较大，当前仅展示部分数据。如需查看更多，请点击",
      c_load_more:"加载更多",
      c_loading:"数据加载中",
      c_loading_large:"数据量较大，正在加载中...",
      c_loading_all:"正在加载全部数据...",
    }
  };



// WEBPACK FOOTER //
// ./src/local/language/cn.js